var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Crear VOD" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-autocomplete", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "tfClassModal",
                                attrs: {
                                  items: _vm.formFields.patent.items,
                                  label: _vm.formFields.patent.label,
                                  "item-text": "desc",
                                  "item-value": "cod",
                                  "data-vv-name": "patenteRequeridaCrear",
                                  "error-messages": _vm.errors.collect(
                                    "patenteRequeridaCrear"
                                  ),
                                  required: "",
                                  closeOnContentClick: true
                                },
                                on: { change: _vm.changePatent },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            staticStyle: {
                                              height: "100%",
                                              width: "113%",
                                              "margin-left": "-15px",
                                              background: "white"
                                            },
                                            attrs: { elevation: "0" }
                                          },
                                          [
                                            _c(
                                              "v-list-tile",
                                              [
                                                _c(
                                                  "v-list-tile-content",
                                                  {
                                                    staticStyle: {
                                                      overflow:
                                                        "visible !important"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          display: "flex",
                                                          "margin-left": "5%",
                                                          "margin-right": "5%",
                                                          cursor:
                                                            "pointer !important"
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "material-icons",
                                                          style: _vm.getHtmlFromState(
                                                            data.item.estado
                                                          ),
                                                          attrs: {
                                                            id: "5545",
                                                            title: _vm.getStateString(
                                                              data.item.estado
                                                            )
                                                          }
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tooltipModal",
                                                            staticStyle: {
                                                              "padding-left":
                                                                "16px",
                                                              "margin-top": "2%"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "4%"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      _vm.textoComprimido(
                                                                        data
                                                                          .item
                                                                          .patente +
                                                                          " [" +
                                                                          data
                                                                            .item
                                                                            .cod +
                                                                          "]"
                                                                      )
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " \n                            "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tooltiptextModal"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    data.item
                                                                      .patente +
                                                                      " [" +
                                                                      data.item
                                                                        .cod +
                                                                      "]"
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.formFields.patent.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.patent,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.patent.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-flex", {
                            attrs: { xs12: "", sm6: "", md6: "" }
                          }),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("DateComponent", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "tfClassModal",
                                attrs: {
                                  label: _vm.formFields.dateStart.label,
                                  "data-vv-name": "fechaRequeridaCrear",
                                  "error-messages": _vm.errors.collect(
                                    "fechaRequeridaCrear"
                                  ),
                                  required: ""
                                },
                                model: {
                                  value: _vm.formFields.dateStart.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.dateStart,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.dateStart.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("TimeComponent", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "tfClassModal",
                                attrs: {
                                  label: _vm.formFields.timeStart.label,
                                  "data-vv-name": "horaRequeridaCrear",
                                  "error-messages": _vm.errors.collect(
                                    "horaRequeridaCrear"
                                  ),
                                  required: ""
                                },
                                model: {
                                  value: _vm.formFields.timeStart.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.timeStart,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.timeStart.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("DateComponent", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "tfClassModal",
                                attrs: {
                                  label: _vm.formFields.dateEnd.label,
                                  "data-vv-name": "fechaFinRequeridaCrear",
                                  "error-messages": _vm.errors.collect(
                                    "fechaFinRequeridaCrear"
                                  ),
                                  required: ""
                                },
                                model: {
                                  value: _vm.formFields.dateEnd.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.dateEnd,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.dateEnd.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("TimeComponent", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "tfClassModal",
                                attrs: {
                                  label: _vm.formFields.timeEnd.label,
                                  "data-vv-name": "horaFinRequeridaCrear",
                                  "error-messages": _vm.errors.collect(
                                    "horaFinRequeridaCrear"
                                  ),
                                  required: ""
                                },
                                model: {
                                  value: _vm.formFields.timeEnd.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.timeEnd,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.timeEnd.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("v-textField", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "emailFormato",
                                    expression: "'emailFormato'"
                                  }
                                ],
                                attrs: {
                                  "prepend-inner-icon": "mail",
                                  label: _vm.formFields.emails.label,
                                  "error-messages": _vm.errors.collect(
                                    "emailFormato"
                                  ),
                                  "data-vv-name": "emailFormato"
                                },
                                model: {
                                  value: _vm.formFields.emails.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.emails,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.emails.value"
                                }
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    "text-align": "left"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                *Se pueden agregar varios correos separados por ;\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    display: "flex",
                                    "justify-content": "flex-end"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: { height: "47px" },
                                      attrs: { color: "#ffe800" },
                                      on: { click: _vm.handleClick }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            left: "",
                                            dark: "",
                                            icon: ""
                                          }
                                        },
                                        [_vm._v("add")]
                                      ),
                                      _vm._v(" Crear VOD\n                ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        2
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }